// FilePond
import * as FilePond from 'filepond';
window.FilePond = FilePond;
import 'filepond/dist/filepond.min.css';

// [ https://pqina.nl/filepond/docs/api/plugins/image-exif-orientation/ ]
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
window.FilePondPluginImageExifOrientation = FilePondPluginImageExifOrientation;

// [ https://pqina.nl/filepond/docs/api/plugins/image-edit/ ]
import FilePondPluginImageEdit from 'filepond-plugin-image-edit';
window.FilePondPluginImageEdit = FilePondPluginImageEdit;
import 'filepond-plugin-image-edit/dist/filepond-plugin-image-edit.css';

// [ https://pqina.nl/filepond/docs/api/plugins/file-metadata/ ]
import FilePondPluginFileMetadata from 'filepond-plugin-file-metadata';
window.FilePondPluginFileMetadata = FilePondPluginFileMetadata;

// [ https://pqina.nl/filepond/docs/api/plugins/file-validate-type/ ]
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
window.FilePondPluginFileValidateType = FilePondPluginFileValidateType;

// [ https://pqina.nl/filepond/docs/api/plugins/file-validate-size/ ]
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
window.FilePondPluginFileValidateSize = FilePondPluginFileValidateSize;

// [ https://pqina.nl/filepond/docs/api/plugins/image-validate-size/ ]
import FilePondPluginImageValidateSize from 'filepond-plugin-image-validate-size';
window.FilePondPluginImageValidateSize = FilePondPluginImageValidateSize;

// [ https://pqina.nl/filepond/docs/api/plugins/image-preview/ ]
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
window.FilePondPluginImagePreview = FilePondPluginImagePreview;
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';

// [ https://pqina.nl/filepond/docs/api/plugins/image-crop/ ]
import FilePondPluginImageCrop from 'filepond-plugin-image-crop';
window.FilePondPluginImageCrop = FilePondPluginImageCrop;

// [ https://pqina.nl/filepond/docs/api/plugins/image-resize/ ]
import FilePondPluginImageResize from 'filepond-plugin-image-resize';
window.FilePondPluginImageResize = FilePondPluginImageResize;

// [ https://pqina.nl/filepond/docs/api/plugins/image-transform/ ]
import FilePondPluginImageTransform from 'filepond-plugin-image-transform';
window.FilePondPluginImageTransform = FilePondPluginImageTransform;

// [ https://github.com/nielsboogaard/filepond-plugin-get-file ]
import FilePondPluginGetFile from 'filepond-plugin-get-file';
window.FilePondPluginGetFile = FilePondPluginGetFile;
import 'filepond-plugin-get-file/dist/filepond-plugin-get-file.min.css';